export default {
    // Home page
    home: {
        title: 'Timer.today • Timer Online Terbaik, Stopwatch & Jam Dunia',
        description: '⏰ Alat penghitung waktu online gratis termasuk timer hitung mundur, stopwatch presisi, dan jam dunia. Sempurna untuk produktivitas, memasak, belajar, pelatihan olahraga dan manajemen zona waktu. Tanpa iklan.',
        keywords: ['timer online', 'timer hitung mundur', 'stopwatch online', 'jam dunia', 'timer produktivitas', 'timer pomodoro', 'timer masak', 'alat timer gratis', 'timer browser', 'manajemen waktu'],
        ogTitle: 'Alat Timer Online Profesional - timer.today',
        ogDescription: 'Platform alat penghitung waktu online profesional yang menyediakan fitur timer hitung mundur, stopwatch dan jam dunia',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Timer.Today",
            "description": "Alat penghitung waktu online gratis termasuk timer hitung mundur, stopwatch presisi, dan jam dunia. Sempurna untuk produktivitas, memasak, belajar, pelatihan olahraga dan manajemen zona waktu. Tanpa iklan.",
            "url": "https://timer.today",
            "applicationCategory": "Productivity",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "Timer online",
                "Peringatan suara",
                "Preset timer berganda",
                "Stopwatch",
                "Jam dunia"
            ],
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "reviewCount": "503"
            }
        }
    },

    // Timer page
    timer: {
        // Optimasi tag SEO utama
        title: 'Timer Online • Alat Hitung Mundur Gratis dengan Peringatan Suara',
        description: '⏰ Timer hitung mundur online dengan pengaturan khusus. Mulai cepat 10mnt/15mnt untuk Pomodoro, belajar, istirahat kerja. Gratis + peringatan suara 🔔!',

        // Optimasi kata kunci
        keywords: [
            'timer 10 menit', 'timer 15 menit', 'timer 30 menit',
            'timer pomodoro', 'timer belajar', 'timer istirahat kerja',
            'timer dengan peringatan suara', 'alat hitung mundur online',
            'timer produktivitas', 'alat manajemen waktu'
        ],

        // Optimasi SEO media sosial
        ogTitle: 'Timer Online Gratis - Sempurna untuk Belajar & Istirahat Kerja',
        ogDescription: '⏰ Atur timer hitung mundur khusus dengan peringatan suara. Sempurna untuk teknik Pomodoro, sesi belajar, dan produktivitas. Tidak perlu mendaftar!',
        ogUrl: 'https://timer.today/timer',

        // Optimasi Twitter
        twitterTitle: 'Timer Online Gratis - Tingkatkan Produktivitas Anda',
        twitterDescription: '⏰ Timer hitung mundur khusus dengan peringatan suara. Sempurna untuk Pomodoro, istirahat belajar, dan manajemen waktu. Mulai sekarang!',
        twitterCard: 'summary_large_image',

        // Optimasi data terstruktur
        jsonLd:
            {
                "@context": "https://schema.org",
                "@type": "WebApplication",
                "name": "Timer Online - Alat Hitung Mundur Gratis",
                "description": "Timer hitung mundur online gratis dengan pengaturan waktu khusus, peringatan suara, dan opsi preset. Sempurna untuk produktivitas dan manajemen waktu.",
                "url": "https://timer.today/timer",
                "applicationCategory": "Productivity",
                "operatingSystem": "Any",
                "browserRequirements": "Requires JavaScript",
                "offers": {
                    "@type": "Offer",
                    "price": "0",
                    "priceCurrency": "USD",
                    "availability": "https://schema.org/InStock"
                },
                "features": [
                    {
                        "@type": "WebPage",
                        "name": "Timer 1 menit",
                        "url": "https://timer.today/timer/1-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "Timer 3 menit",
                        "url": "https://timer.today/timer/3-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "Timer 5 menit",
                        "url": "https://timer.today/timer/5-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "Timer 10 menit",
                        "url": "https://timer.today/timer/10-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "Timer 15 menit",
                        "url": "https://timer.today/timer/15-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "Timer 30 menit",
                        "url": "https://timer.today/timer/30-minute-timer"
                    }
                ],
                "isAccessibleForFree": true,
                "publisher": {
                    "@type": "Organization",
                    "name": "Timer.Today",
                    "url": "https://timer.today"
                },
                "potentialAction": {
                    "@type": "UseAction",
                    "target": "https://timer.today/timer",
                    "name": "Mulai Timer"
                },
                "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": "4.8",
                    "ratingCount": "70",
                    "bestRating": "5"
                }
            }
    },

    // Stopwatch page
    stopwatch: {
        title: 'Stopwatch Online • Timer Presisi Tinggi dengan Milidetik',

        description: '⏱️ Stopwatch online profesional dengan presisi milidetik. Sempurna untuk pelatihan olahraga, latihan kebugaran, waktu memasak & belajar. Gratis + akurat! 🎯',

        keywords: [
            'stopwatch online', 'stopwatch presisi', 'timer milidetik',
            'stopwatch digital', 'stopwatch gratis', 'stopwatch akurat',
            'stopwatch dengan milidetik', 'timer presisi tinggi',
            'stopwatch profesional', 'timer lap', 'timer split',
            'timer olahraga', 'stopwatch pelatihan', 'timer kebugaran',
            'stopwatch memasak', 'timer latihan', 'stopwatch lari',
            'timer belajar', 'timer interval', 'stopwatch balap'
        ],

        // Optimasi media sosial
        ogTitle: 'Stopwatch Online Gratis - Timer Presisi Milidetik',
        ogDescription: '⏱️ Stopwatch profesional dengan waktu presisi untuk olahraga, kebugaran, memasak & pelatihan. Akurasi milidetik, waktu lap, dan split timing. Mulai sekarang!',
        ogUrl: 'https://timer.today/stopwatch',

        // Optimasi Twitter
        twitterTitle: 'Stopwatch Online Presisi - Sempurna untuk Olahraga & Pelatihan',
        twitterDescription: '⏱️ Stopwatch presisi tinggi dengan akurasi milidetik. Sempurna untuk atlet, pelatih, dan siapa pun yang membutuhkan pengukuran waktu presisi.',
        twitterCard: 'summary_large_image',

        // Optimasi data terstruktur menyeluruh
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Stopwatch Online - Timer Presisi Tinggi",
            "description": "Stopwatch online profesional dengan presisi milidetik. Sempurna untuk pelatihan olahraga, latihan kebugaran, waktu memasak, dan pengukuran waktu yang tepat.",
            "url": "https://timer.today/stopwatch",
            "applicationCategory": "Productivity",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",

            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD",
                "availability": "https://schema.org/InStock"
            },

            "featureList": [
                "Penghitungan waktu presisi milidetik",
                "Kontrol mulai, berhenti, atur ulang",
                "Layar penuh",
                "Notifikasi suara",
                "Tanpa iklan"
            ],

            "isAccessibleForFree": true,

            "publisher": {
                "@type": "Organization",
                "name": "Timer.Today",
                "url": "https://timer.today"
            },

            "relatedLink": [
                "https://timer.today/timer",
                "https://timer.today/worldclock"
            ],

            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.7",
                "ratingCount": "89",
                "bestRating": "5"
            }
        }
    },

    // World Clock page
    worldclock: {
        title: 'Jam Dunia • Zona Waktu Global Langsung & Waktu Saat Ini',

        description: '🌍 Jam dunia langsung menampilkan waktu saat ini di 200+ kota di seluruh dunia. Zona waktu real-time, perencana rapat & konverter zona waktu. Gratis & akurat! ⏰',

        keywords: [
            'jam dunia', 'zona waktu global', 'waktu sekarang', 'konverter zona waktu',
            'waktu di india', 'waktu new york', 'waktu konferensi global',
            'jam dunia langsung', 'jam dunia real time', 'waktu dunia saat ini',
            'zona waktu usa', 'zona waktu eropa', 'zona waktu asia',
            'waktu new york', 'waktu london', 'waktu tokyo', 'waktu sydney',
            'jam berapa sekarang di seluruh dunia', 'perbandingan waktu internasional'
        ],

        // Optimasi media sosial
        ogTitle: 'Jam Dunia Langsung - Waktu Saat Ini di 200+ Kota Global',
        ogDescription: '🌍 Periksa waktu saat ini di seluruh dunia secara instan! Sempurna untuk rapat bisnis internasional, perencanaan perjalanan, dan tetap terhubung secara global. Pembaruan langsung gratis!',
        ogImage: 'https://timer.today/images/worldclock-social-preview.jpg',
        ogUrl: 'https://timer.today/worldclock',

        // Optimasi Twitter
        twitterTitle: 'Jam Dunia - Jangan Pernah Lewatkan Waktu Rapat Global',
        twitterDescription: '🌍 Jam dunia langsung dengan 200+ kota. Sempurna untuk bisnis internasional, perjalanan, dan koordinasi global. Pembaruan real-time!',
        twitterCard: 'summary_large_image',

        // Optimasi data terstruktur menyeluruh
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Jam Dunia - Zona Waktu Global Langsung",
            "description": "Jam dunia real-time menampilkan waktu saat ini di lebih dari 200 kota besar di seluruh dunia. Sempurna untuk bisnis internasional, perencanaan perjalanan, dan koordinasi global.",
            "url": "https://timer.today/worldclock",
            "applicationCategory": "Productivity",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",

            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD",
                "availability": "https://schema.org/InStock"
            },

            "featureList": [
                "Tampilan waktu langsung untuk 200+ kota",
                "Pembaruan zona waktu real-time",
                "Perbandingan zona waktu ganda",
                "Tandai kota favorit",
                "Layar penuh"
            ],

            "serviceArea": [
                {"@type": "Place", "name": "Amerika Utara"},
                {"@type": "Place", "name": "Eropa"},
                {"@type": "Place", "name": "Asia Pasifik"},
                {"@type": "Place", "name": "Timur Tengah"},
                {"@type": "Place", "name": "Afrika"},
                {"@type": "Place", "name": "Oseania"},
                {"@type": "Place", "name": "Seluruh Dunia"}
            ],

            "isAccessibleForFree": true,

            "publisher": {
                "@type": "Organization",
                "name": "Timer.Today",
                "url": "https://timer.today"
            }
        }
    },

    // Not Found page
    notfound: {
        title: 'Halaman Tidak Ditemukan - timer.today',
        description: 'Maaf, halaman yang Anda cari tidak ada. Kembali ke beranda kami untuk menggunakan alat timer online, stopwatch, dan jam dunia kami.',
        keywords: ['404', 'tidak ditemukan', 'alat timer'],
        ogTitle: 'Halaman Tidak Ditemukan - timer.today',
        ogDescription: 'Halaman yang Anda cari tidak ada'
    },

    // Terms page
    terms: {
        title: 'Syarat Layanan - timer.today',
        description: 'Syarat Layanan dan perjanjian penggunaan untuk platform alat penghitung waktu online timer.today. Pelajari tentang aturan layanan kami, hak pengguna, dan tanggung jawab.',
        keywords: ['syarat layanan', 'perjanjian pengguna', 'syarat alat timer'],
        ogTitle: 'Syarat Layanan - timer.today',
        ogDescription: 'Syarat Layanan dan perjanjian penggunaan untuk platform alat penghitung waktu online timer.today',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Syarat Layanan",
            "description": "Syarat Layanan dan perjanjian penggunaan untuk platform alat penghitung waktu online timer.today"
        }
    },

    // Dynamic timer pages (1min, 3min, etc.)
    timerMinutes: (minutesNum: number) => {
        const useCases = {
            1: 'istirahat mata, meditasi cepat, menyeduh teh',
            3: 'merebus telur, menyeduh kopi, istirahat singkat',
            5: 'praktik meditasi, telur setengah matang, latihan cepat',
            10: 'istirahat belajar, panggilan telepon, sesi membaca',
            15: 'sesi kerja Pomodoro, latihan menengah, pembelajaran mendalam',
            20: 'periode kerja terfokus, latihan kebugaran, pelatihan keterampilan',
            25: 'teknik Pomodoro standar, pekerjaan mendalam, studi profesional',
            30: 'sesi fokus panjang, rutinitas latihan, pembelajaran mendalam',
            45: 'periode pekerjaan mendalam, praktik pidato, pelatihan profesional',
            60: 'blok waktu kerja, pembelajaran kursus, latihan diperpanjang'
        }[minutesNum] || 'produktivitas dan manajemen waktu';

        return {
            title: `Timer ${minutesNum} Menit - Alat Hitung Mundur Online untuk Produktivitas`,
            description: `Timer hitung mundur gratis ${minutesNum} menit sempurna untuk ${useCases}. Fitur peringatan suara, mode layar penuh, dan pengaturan khusus. Mulai timer ${minutesNum} menit Anda sekarang!`,
            keywords: [`timer ${minutesNum} menit`, `timer ${minutesNum}mnt`, 'timer hitung mundur', 'timer produktivitas', useCases.split(', ')[0], useCases.split(', ')[1]],
            ogTitle: `Timer ${minutesNum} Menit - timer.today`,
            ogDescription: `Timer hitung mundur ${minutesNum} menit dengan peringatan suara dan notifikasi desktop, sempurna untuk ${useCases}`,
            jsonLd: {
                "@context": "https://schema.org",
                "@type": "WebApplication",
                "name": `Timer ${minutesNum} Menit`,
                "description": `Timer hitung mundur ${minutesNum} menit dengan peringatan suara dan notifikasi desktop, sempurna untuk ${useCases}`,
                "applicationCategory": "Productivity"
            }
        };
    },

    // Dynamic city pages
    city: ({ cityName, countryName, timezone }: { cityName: string, countryName: string, timezone: string }) => ({
        title: `Waktu Saat Ini di ${cityName} - Jam Langsung ${cityName} & Zona Waktu`,
        description: `🌍 Jam berapa sekarang di ${cityName}, ${countryName}? Periksa waktu lokal saat ini, zona waktu (${timezone}), offset UTC, dan tanggal. Sempurna untuk menjadwalkan rapat dan panggilan internasional. Pembaruan langsung gratis!`,
        keywords: [
            `waktu di ${cityName}`,
            `waktu ${cityName}`,
            `waktu saat ini ${cityName}`,
            `zona waktu ${cityName}`,
            `jam ${cityName}`,
            `jam berapa sekarang di ${cityName}`,
            `waktu lokal ${cityName}`,
            `zona waktu ${cityName}`,
            `waktu ${cityName} ${countryName}`,
            'jam dunia',
            'waktu internasional'
        ],
        ogTitle: `Waktu Saat Ini di ${cityName}, ${countryName} - Jam Langsung`,
        ogDescription: `Periksa waktu saat ini di ${cityName} (${timezone}). Pembaruan real-time dengan informasi zona waktu dan tanggal. Sempurna untuk penjadwalan internasional.`,
        ogUrl: `https://timer.today/worldclock/time-in/${cityName.toLowerCase().replace(/\s+/g, '-')}`,
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": `Waktu Saat Ini di ${cityName}`,
            "description": `Waktu lokal saat ini di ${cityName}, ${countryName} dengan zona waktu ${timezone}`,
            "url": `https://timer.today/worldclock/time-in/${cityName.toLowerCase().replace(/\s+/g, '-')}`,
            "isPartOf": {
                "@type": "WebSite",
                "name": "Timer.Today",
                "url": "https://timer.today"
            },
            "about": {
                "@type": "Place",
                "name": cityName,
                "address": {
                    "@type": "PostalAddress",
                    "addressCountry": countryName
                }
            },
            "mainEntity": {
                "@type": "ClockInfo",
                "name": `Waktu ${cityName}`,
                "timezone": timezone
            }
        }
    }),

    // Timestamp converter page
    timestamp: {
        title: 'Konverter Timestamp Unix - Waktu Epoch ke Tanggal & Potongan Kode | timer.today',
        description: 'Konverter timestamp Unix online gratis. Konversi waktu epoch ke tanggal dan sebaliknya. Termasuk lembar curang timestamp untuk Python, Java, MySQL, JavaScript, dan PHP.',
        keywords: [
            'konverter timestamp',
            'timestamp unix',
            'konverter waktu epoch',
            'timestamp ke tanggal',
            'tanggal ke timestamp',
            'konverter waktu unix',
            'timestamp python',
            'timestamp java',
            'timestamp mysql',
            'timestamp javascript',
            'timestamp php',
            'iso 8601',
            'waktu epoch saat ini',
            'lembar curang timestamp'
        ],
        ogTitle: 'Konverter Timestamp Unix & Alat Waktu Epoch',
        ogDescription: 'Konversi waktu epoch ke tanggal dengan contoh kode untuk Python, Java, MySQL, JavaScript, dan PHP. Konverter timestamp online gratis.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Konverter Timestamp Unix",
            "description": "Konverter timestamp Unix online gratis dengan potongan kode untuk Python, Java, MySQL, JavaScript, dan PHP",
            "url": "https://timer.today/timestamp",
            "applicationCategory": "DeveloperApplication",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "Konversi timestamp unix ke tanggal",
                "Konversi tanggal ke timestamp",
                "Tampilan waktu epoch saat ini",
                "Contoh kode untuk Python, Java, MySQL, JavaScript, PHP",
                "Dukungan format detik dan milidetik",
                "Output format ISO 8601"
            ]
        }
    },

    // YouTube Timestamp Link Generator
    youtubeLink: {
        title: 'Pembuat Tautan Timestamp YouTube - Buat Tautan Video yang Dapat Dibagikan | timer.today',
        description: '📺 Buat tautan YouTube yang mulai pada waktu tertentu. Sempurna untuk berbagi momen video di media sosial, email, dan forum. Bekerja dengan semua video YouTube!',
        keywords: [
            'tautan timestamp youtube',
            'timestamp youtube',
            'tautan youtube dengan timestamp',
            'tautan youtube pada waktu tertentu',
            'bagikan timestamp youtube',
            'url timestamp youtube',
            'tautan waktu mulai youtube',
            'timestamp video youtube',
            'pembuat timestamp youtube',
            'pembuat tautan youtube',
            'timestamp embedding youtube'
        ],
        ogTitle: 'Pembuat Tautan Timestamp YouTube - Bagikan Video pada Momen Tepat',
        ogDescription: 'Buat tautan YouTube yang mulai kapan saja. Buat URL yang dapat dibagikan untuk media sosial, email, dan kode embedding dengan timestamp.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Pembuat Tautan Timestamp YouTube",
            "description": "Buat tautan YouTube dengan timestamp untuk berbagi momen video tertentu",
            "url": "https://timer.today/youtube-timestamp-link",
            "applicationCategory": "UtilitiesApplication",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "Buat tautan YouTube pendek dan lengkap",
                "Buat kode embedding dengan timestamp",
                "Pratinjau video langsung",
                "Dukungan format URL ganda",
                "Salin satu klik"
            ]
        }
    },

    // YouTube Timestamp Generator (for chapters/comments)
    youtubeGenerator: {
        title: 'Pembuat Timestamp YouTube - Buat Bab & Komentar Video | timer.today',
        description: '🎬 Buat timestamp YouTube untuk deskripsi video dan komentar. Buat bab, ubah detik menjadi timestamp, dan tingkatkan SEO video. Alat gratis!',
        keywords: [
            'pembuat timestamp youtube',
            'timestamp youtube',
            'bab youtube',
            'bab video youtube',
            'komentar timestamp youtube',
            'format timestamp youtube',
            'pembuat bab youtube',
            'konverter timestamp youtube',
            'timestamp deskripsi youtube',
            'timestamp video youtube',
            'cara menambah bab youtube'
        ],
        ogTitle: 'Pembuat Timestamp YouTube - Buat Bab & Komentar',
        ogDescription: 'Buat timestamp berformat untuk deskripsi video YouTube dan komentar. Buat bab untuk meningkatkan pengalaman penonton dan SEO.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Pembuat Timestamp YouTube",
            "description": "Buat timestamp YouTube untuk bab video, deskripsi, dan komentar",
            "url": "https://timer.today/youtube-timestamp-generator",
            "applicationCategory": "UtilitiesApplication",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "Pembuat bab video",
                "Konverter detik ke timestamp",
                "Template timestamp komentar",
                "Konversi batch",
                "Validasi format"
            ]
        }
    },

    // MySQL Timestamp Page
    mysqlTimestamp: {
        title: 'Tutorial Timestamp MySQL - Panduan UNIX_TIMESTAMP & FROM_UNIXTIME | timer.today',
        description: '📘 Panduan timestamp MySQL lengkap. Pelajari UNIX_TIMESTAMP(), FROM_UNIXTIME(), TIMESTAMP vs DATETIME, penanganan zona waktu, dan optimasi kinerja dengan contoh SQL praktis.',
        keywords: [
            'timestamp mysql',
            'mysql unix_timestamp',
            'mysql from_unixtime',
            'timestamp ke tanggal mysql',
            'tanggal ke timestamp mysql',
            'format timestamp mysql',
            'timestamp vs datetime mysql',
            'zona waktu timestamp mysql',
            'current timestamp mysql',
            'fungsi timestamp mysql',
            'waktu epoch mysql'
        ],
        ogTitle: 'Tutorial Timestamp MySQL - Panduan Lengkap dengan Contoh SQL',
        ogDescription: 'Kuasai fungsi timestamp MySQL: UNIX_TIMESTAMP(), FROM_UNIXTIME(), penanganan zona waktu, dan tips kinerja. Termasuk contoh SQL praktis.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "name": "Panduan Lengkap Timestamp MySQL",
            "description": "Tutorial komprehensif tentang fungsi timestamp MySQL dan praktik terbaik",
            "url": "https://timer.today/mysql-timestamp",
            "author": {
                "@type": "Organization",
                "name": "Timer.Today"
            },
            "datePublished": "2024-01-04",
            "educationalLevel": "Intermediate",
            "proficiencyLevel": "Intermediate"
        }
    },

    // SQL Timestamp Page (Universal)
    sqlTimestamp: {
        title: 'Tutorial Timestamp SQL - MySQL, PostgreSQL, Oracle, SQL Server | timer.today',
        description: '📘 Panduan timestamp SQL lengkap untuk semua database utama. Kuasai UNIX_TIMESTAMP MySQL, EXTRACT(EPOCH) PostgreSQL, aritmatika tanggal Oracle, dan DATEDIFF_BIG SQL Server dengan contoh praktis.',
        keywords: [
            'timestamp sql',
            'timestamp mysql',
            'timestamp postgresql',
            'timestamp oracle',
            'timestamp sql server',
            'timestamp unix sql',
            'timestamp ke tanggal sql',
            'tanggal ke timestamp sql',
            'current timestamp sql',
            'fungsi timestamp sql',
            'timestamp sql',
            'format timestamp sql',
            'perbandingan timestamp sql',
            'waktu epoch sql',
            'timestamp database'
        ],
        ogTitle: 'Tutorial Timestamp SQL - Panduan Lengkap untuk Semua Database Utama',
        ogDescription: 'Kuasai penanganan timestamp di MySQL, PostgreSQL, Oracle, dan SQL Server. Panduan komprehensif dengan perbandingan sintaks dan contoh SQL praktis.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "name": "Panduan Lengkap Timestamp SQL untuk Semua Database",
            "description": "Tutorial komprehensif tentang fungsi timestamp di MySQL, PostgreSQL, Oracle, dan SQL Server",
            "url": "https://timer.today/sql-timestamp",
            "author": {
                "@type": "Organization",
                "name": "Timer.Today"
            },
            "datePublished": "2025-01-05",
            "dateModified": "2025-01-05",
            "educationalLevel": "Intermediate",
            "proficiencyLevel": "Intermediate",
            "keywords": "SQL, MySQL, PostgreSQL, Oracle, SQL Server, timestamp, database"
        }
    },

    // Python Timestamp Page
    pythonTimestamp: {
        title: 'Tutorial Timestamp Python - Panduan Modul datetime, time, calendar | timer.today',
        description: '🐍 Panduan timestamp Python lengkap. Kuasai modul datetime, time, dan calendar. Pelajari penanganan zona waktu, konversi timestamp, dan contoh kode praktis.',
        keywords: [
            'timestamp python',
            'dapatkan timestamp python',
            'timestamp datetime python',
            'timestamp ke datetime python',
            'datetime ke timestamp python',
            'timestamp time python',
            'timestamp ke tanggal python',
            'timestamp unix python',
            'zona waktu timestamp python',
            'milidetik timestamp python'
        ],
        ogTitle: 'Tutorial Timestamp Python - Panduan Modul datetime & time',
        ogDescription: 'Kuasai penanganan timestamp Python dengan modul datetime, time, dan calendar. Termasuk penanganan zona waktu dan contoh praktis.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "name": "Panduan Lengkap Timestamp Python",
            "description": "Tutorial komprehensif tentang penanganan timestamp Python dengan modul datetime dan time",
            "url": "https://timer.today/python-timestamp",
            "programmingLanguage": "Python"
        }
    },

    // JavaScript Timestamp Page
    javascriptTimestamp: {
        title: 'Tutorial Timestamp JavaScript - Panduan Objek Date & Metode | timer.today',
        description: '⚡ Panduan timestamp JavaScript lengkap. Kuasai objek Date, Date.now(), getTime(), konversi timestamp, dan perpustakaan populer seperti Day.js.',
        keywords: [
            'timestamp javascript',
            'js timestamp',
            'dapatkan timestamp javascript',
            'timestamp date javascript',
            'date.now javascript',
            'timestamp ke tanggal javascript',
            'tanggal ke timestamp javascript',
            'timestamp unix javascript',
            'milidetik timestamp javascript',
            'javascript date gettime'
        ],
        ogTitle: 'Tutorial Timestamp JavaScript - Panduan Objek Date',
        ogDescription: 'Kuasai objek Date JavaScript dan metode timestamp. Termasuk perpustakaan modern dan contoh praktis.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "name": "Panduan Lengkap Timestamp JavaScript",
            "description": "Tutorial komprehensif tentang objek Date JavaScript dan penanganan timestamp",
            "url": "https://timer.today/javascript-timestamp",
            "programmingLanguage": "JavaScript"
        }
    },

    // Discord Timestamp Generator
    discordTimestamp: {
        title: 'Pembuat Timestamp Discord - Buat Kode <t:format> | timer.today',
        description: '🎮 Buat timestamp Discord dengan konversi zona waktu otomatis. Buat kode <t:timestamp:format> untuk acara, hitungan mundur, dan pengumuman. Bekerja di semua saluran Discord!',
        keywords: [
            'timestamp discord',
            'pembuat timestamp discord',
            'format waktu discord',
            'kode timestamp discord',
            'format <t> discord',
            'konverter timestamp discord',
            'timestamp dinamis discord',
            'konverter waktu discord',
            'timestamp acara discord',
            'hitung mundur discord',
            'konverter zona waktu discord'
        ],
        ogTitle: 'Pembuat Timestamp Discord - Konversi Zona Waktu Otomatis',
        ogDescription: 'Buat kode timestamp Discord yang secara otomatis menyesuaikan dengan zona waktu lokal setiap pengguna. Sempurna untuk acara, raid, dan penjadwalan komunitas.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Pembuat Timestamp Discord",
            "description": "Buat kode timestamp Discord dengan konversi zona waktu otomatis untuk acara dan pengumuman",
            "url": "https://timer.today/discord-timestamp-generator",
            "applicationCategory": "UtilitiesApplication",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "7 format timestamp Discord",
                "Konversi zona waktu otomatis",
                "Pratinjau langsung",
                "Salin satu klik",
                "Tabel referensi format",
                "Panduan kasus penggunaan umum"
            ]
        }
    },

    // Dynamic country pages
    country: ({ countryName, citiesCount }: { countryName: string, citiesCount: number }) => ({
        title: `Waktu di ${countryName} - Waktu Lokal Saat Ini & Zona Waktu`,
        description: `🌍 Periksa waktu saat ini di ${countryName} di ${citiesCount}+ kota. Pembaruan zona waktu real-time, offset UTC, dan waktu lokal. Sempurna untuk rapat bisnis dan koordinasi internasional.`,
        keywords: [
            `waktu di ${countryName}`,
            `waktu ${countryName}`,
            `zona waktu ${countryName}`,
            `waktu saat ini ${countryName}`,
            `jam ${countryName}`,
            `jam berapa sekarang di ${countryName}`,
            `waktu lokal ${countryName}`,
            `waktu kota ${countryName}`,
            'jam dunia',
            'waktu internasional'
        ],
        ogTitle: `Waktu Saat Ini di ${countryName} - ${citiesCount}+ Kota`,
        ogDescription: `Lihat waktu saat ini di ${countryName} di semua kota besar. Informasi zona waktu real-time dengan pembaruan langsung.`,
        ogUrl: `https://timer.today/worldclock/country/${countryName.toLowerCase().replace(/\s+/g, '-')}`,
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": `Waktu di ${countryName}`,
            "description": `Waktu lokal saat ini di ${countryName} mencakup ${citiesCount}+ kota`,
            "url": `https://timer.today/worldclock/country/${countryName.toLowerCase().replace(/\s+/g, '-')}`,
            "isPartOf": {
                "@type": "WebSite",
                "name": "Timer.Today",
                "url": "https://timer.today"
            },
            "about": {
                "@type": "Place",
                "name": countryName,
                "geo": {
                    "@type": "Country",
                    "name": countryName
                }
            }
        }
    })
};
